// Global Configuration for Game Pro Hub
// Centralized API source of truth - Defensive Purge of Render.com

const GCP_URL = "https://miraia-api-888383430095.us-central1.run.app";

const API_URL_ENV = (process.env.REACT_APP_API_URL || '').trim();
const IS_LOCAL = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
const IS_RELATIVE_API_URL = API_URL_ENV.startsWith("/");
const SHOULD_USE_ENV_API_URL = Boolean(API_URL_ENV) && (IS_LOCAL || !IS_RELATIVE_API_URL);

// Safe dynamic detection for local dev resilience
export const FINAL_API_URL = 
  (SHOULD_USE_ENV_API_URL ? API_URL_ENV : "") ||
  (IS_LOCAL ? "http://localhost:8000" : GCP_URL);

// Derived URLs
export const BACKEND_URL = FINAL_API_URL.replace('/api', '');
export const API_URL = FINAL_API_URL.includes('/api') ? FINAL_API_URL : `${FINAL_API_URL}/api`;

// 🛡️ FEATURE FLAGS 🛡️
// Protected rollout for the premium OS-level UX overhaul
export const IA_IMMERSIVE_MODE = true;

// MI COACH V4: Massive refactoring flag
export const MI_COACH_V4_ENABLED = process.env.REACT_APP_MI_COACH_V4_ENABLED === 'true';
